import 'dayjs/locale/ru';

import { DatePickerLocalizationProps } from '@diagentech/exprworks-ui-components';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { enUS, ruRU } from '@mui/x-date-pickers/locales';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { MRT_Localization_RU } from 'material-react-table/locales/ru';
import { MRT_Localization } from 'material-react-table/src/types';

import { LocaleType } from '@/App/types';

interface MaterialReactTableLocalizationProps {
  mrtLocaleText: MRT_Localization;
}

type LocalizationProps = DatePickerLocalizationProps & MaterialReactTableLocalizationProps;

type LocalizationMap = {
  [key in LocaleType]: LocalizationProps;
};

const localizationMap: LocalizationMap = {
  en: {
    localeText: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
    mrtLocaleText: MRT_Localization_EN,
  },
  ru: {
    adapterLocale: 'ru',
    localeText: ruRU.components.MuiLocalizationProvider.defaultProps.localeText,
    mrtLocaleText: MRT_Localization_RU,
  },
  lv: {
    localeText: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
    mrtLocaleText: MRT_Localization_EN,
  },
};

class LocalizationService {
  getDatePickerLocalization = (locale?: LocaleType): DatePickerLocalizationProps => {
    if (!locale) {
      throw new Error('locale must not be null!');
    }
    const localization = localizationMap[locale];
    return {
      dateAdapter: AdapterDayjs,
      adapterLocale: localization.adapterLocale,
      localeText: localization.localeText,
    };
  };

  getMaterialReactTableLocalization = (locale?: LocaleType): MaterialReactTableLocalizationProps => {
    if (!locale) {
      throw new Error('locale must not be null!');
    }
    const localization = localizationMap[locale];
    return {
      mrtLocaleText: localization.mrtLocaleText,
    };
  };
}

const localizationService = new LocalizationService();

export default localizationService;
